import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

  export const createRole = async (data) => {
      try {
        const response = await api.create(`/roles/add`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getRoles = async () => {
      try {
        const response = await api.get(`/roles/all`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getRoleById = async (id) => {
      try {
        const response = await api.get(`/roles/${id}`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateRole = async ( id, data) => {
      try {
        const response = await api.put(`/roles/update/${id}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteRole = async (id) => {
    try {
        const response = await api.delete('/roles/delete/'+id);
        return response;
    } catch (error) {
        throw error;
    }
  };